import React from 'react';

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";

export default function Identificacao({ boletimVistoria }) {

    return (
        <>
            <h5 className="subtitleCardInfo">Identificação da Vistoria</h5>
            <div className="row align-items-end">
                <div className="col-12 col-lg-12 col-sm-12 pb-2">
                    <strong>Número do Boletim: </strong><span>{boletimVistoria.numeroBoletim}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Concessionária: </strong><span>{boletimVistoria.concessionaria_Identificacao}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Regional: </strong><span>{boletimVistoria.regional_Identificacao}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Fiscal: </strong><span>{boletimVistoria.usuarioFiscal_Nome}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Data/Hora Início: </strong><span>{formateDateandTime(boletimVistoria.dataHoraInicio)}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Data/Hora Fim: </strong><span>{formateDateandTime(boletimVistoria.dataHoraFim)}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Situação da Análise: </strong><span>{boletimVistoria.situacaoAnalise}</span>
                </div>
                <div className="col-6 col-lg-6 col-sm-12 pb-2">
                    <strong>Total de inconformidades para penalidade: </strong><span>{boletimVistoria.totalPenalidades}</span>
                </div>
            </div>
        </>
    );
}
